import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { ITipoServicoCorreios } from '../model/tipo_servico_correios.model';

@Injectable()
export class TipoServicoCorreioService extends EntityService<
  ITipoServicoCorreios
> {
  protected entityName = 'tipo_servico_correios';
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'tipo_servico_correio',
        pluralBaseEntityEndPoint: 'tipos_servicos_correios',
        urlBackend: configService.backendURL
      }
    );
  }
}
